// Copyright (c) Bentley Systems
import Icons from "./Icons";
import ColorfulIconByName, { isColorfulIconName } from "./ColorfulIconByName";

type IconProps = {
  name: string;
  style?: import("react").CSSProperties | undefined;
  toggle?: boolean;
  isFocused?: boolean;
};
const IconByName = (props: IconProps) => {
  const name = props.name.toLowerCase();

  if (isColorfulIconName(name)) {
    return <ColorfulIconByName name={name} style={props.style} />;
  }

  switch (name) {
    case "linkageattribute":
      return <Icons.LinkageAttribute style={props.style} />;
    case "becslogo":
      return <Icons.BecsLogo style={props.style} />;
    case "becsicon":
      return <Icons.BecsIcon style={props.style} />;
    case "log-animated":
      return <Icons.LogAnim isFocused={props.isFocused} />;
    case "log":
      return <Icons.Log style={props.style} />;
    case "administration-animated":
      return <Icons.AdministrationAnim isFocused={props.isFocused} />;
    case "architectsmanagement-animated":
      return <Icons.ArchitectsManagementAnim isFocused={props.isFocused} />;
    case "architectsmanagement":
      return <Icons.ArchitectsManagement style={props.style} />;
    case "subscribedprojects-animated":
      return <Icons.SubscribedProjectsAnim isFocused={props.isFocused} />;
    case "list-animated":
      return <Icons.ListAnim isFocused={props.isFocused} />;
    case "script-run-animated":
      return <Icons.ScriptRunAnim isFocused={props.isFocused} />;
    case "details-animated":
      return <Icons.DetailsAnim isFocused={props.isFocused} />;
    case "monitorlist":
      return <Icons.MonitorList style={props.style} />;
    case "regionaltierlist":
      return <Icons.RegionalTierList style={props.style} />;
    case "packagename":
      return <Icons.PackageName style={props.style} />;
    case "industrylist":
      return <Icons.IndustryList style={props.style} />;
    case "lifecyclelist":
      return <Icons.LifeCycleList style={props.style} />;
    case "executiontypelist":
      return <Icons.ExecutionTypeList style={props.style} />;
    case "confirmscript":
      return <Icons.ConfirmScript style={props.style} />;
    case "attachment":
      return <Icons.Attachment style={props.style} />;
    case "administration":
      return <Icons.Administration style={props.style} />;
    case "statussuccesscolor":
      return <Icons.StatusSuccessColor style={props.style} />;
    case "statussuccesscolormuted":
      return <Icons.StatusSuccessColorMuted style={props.style} />;
    case "imodelvaluelist":
      return <Icons.IModelValueList style={props.style} />;
    case "arexperience":
      return <Icons.ARExperience style={props.style} />;
    case "interoperability":
      return <Icons.Interoperability style={props.style} />;
    case "attributes":
      return <Icons.Attributes style={props.style} />;
    case "colorsettings":
      return <Icons.ColorSettings style={props.style} />;
    case "coloursettings":
      return <Icons.ColourSettings style={props.style} />;
    case "dawwebscreen":
      return <Icons.DawWebScreen style={props.style} />;
    case "mapping":
      return <Icons.Mapping />;
    case "passwordmanagement":
      return <Icons.PasswordManagement style={props.style} />;
    case "tablisting":
      return <Icons.TabListing style={props.style} />;
    case "projects":
      return <Icons.Projects style={props.style} />;
    case "subscribedprojects":
      return <Icons.SubscribedProjects style={props.style} />;
    case "organizations":
      return <Icons.Organizations style={props.style} />;
    case "subscribedorganizations":
      return <Icons.SubscribedOrganizations style={props.style} />;
    case "apitesting":
      return <Icons.ApiTesting style={props.style} />;
    case "onpremrouting":
      return <Icons.OnPremRouting style={props.style} />;
    case "onpremtelemetry":
      return <Icons.SvgActivity style={props.style} />;
    case "2d":
      return <Icons.Svg2D style={props.style} />;
    case "3d":
      return <Icons.Svg3D style={props.style} />;
    case "activity":
      return <Icons.SvgActivity style={props.style} />;
    case "add-circular":
      return <Icons.SvgAddCircular style={props.style} />;
    case "add":
      return <Icons.SvgAdd style={props.style} />;
    case "airplane":
      return <Icons.SvgAirplane style={props.style} />;
    case "align-bottom":
      return <Icons.SvgAlignBottom style={props.style} />;
    case "align-center-horizontal":
      return <Icons.SvgAlignCenterHorizontal style={props.style} />;
    case "align-center-vertical":
      return <Icons.SvgAlignCenterVertical style={props.style} />;
    case "align-left":
      return <Icons.SvgAlignLeft style={props.style} />;
    case "align-right":
      return <Icons.SvgAlignRight style={props.style} />;
    case "align-top":
      return <Icons.SvgAlignTop style={props.style} />;
    case "android":
      return <Icons.SvgAndroid style={props.style} />;
    case "annotation":
      return <Icons.SvgAnnotation style={props.style} />;
    case "apple":
      return <Icons.SvgApple style={props.style} />;
    case "archive":
      return <Icons.SvgArchive style={props.style} />;
    case "arrow-down":
      return <Icons.SvgArrowDown style={props.style} />;
    case "arrow-left":
      return <Icons.SvgArrowLeft style={props.style} />;
    case "arrow-right":
      return <Icons.SvgArrowRight style={props.style} />;
    case "arrow-up":
      return <Icons.SvgArrowUp style={props.style} />;
    case "attach":
      return <Icons.SvgAttach style={props.style} />;
    case "automatic":
      return <Icons.SvgAutomatic style={props.style} />;
    case "away":
      return <Icons.SvgAway style={props.style} />;
    case "menu":
      return <Icons.SvgMenu style={props.style} />;
    case "imodel-hollow":
      return <Icons.SvgImodelHollow style={props.style} />;
    case "edit":
      return <Icons.SvgEdit style={props.style} />;
    case "delete":
      return <Icons.SvgDelete style={props.style} />;
    case "history":
      return <Icons.SvgHistory style={props.style} />;
    case "replace":
      return <Icons.SvgReplace style={props.style} />;
    case "validate":
      return <Icons.SvgValidate style={props.style} />;
    case "user":
      return <Icons.SvgUser style={props.style} />;
    case "users":
      return <Icons.SvgUsers style={props.style} />;
    case "project":
      return <Icons.SvgProject style={props.style} />;
    case "list":
      return <Icons.SvgList style={props.style} />;
    case "plugin":
      return <Icons.SvgPlugin style={props.style} />;
    case "image-frame":
      return <Icons.SvgImageFrame style={props.style} />;
    case "palette":
      return <Icons.SvgPalette style={props.style} />;
    case "sort-down":
      return <Icons.SvgSortDown style={props.style} />;
    case "sort-up":
      return <Icons.SvgSortUp style={props.style} />;
    case "details":
      return <Icons.SvgDetails style={props.style} />;
    case "network":
      return <Icons.SvgNetwork style={props.style} />;
    case "script-run":
      return <Icons.SvgScriptRun style={props.style} />;
    case "basket":
      return <Icons.SvgBasket style={props.style} />;
    case "bentley-systems":
      return <Icons.SvgBentleySystems style={props.style} />;
    case "blank":
      return <Icons.SvgBlank style={props.style} />;
    case "bolt":
      return <Icons.SvgBolt style={props.style} />;
    case "bookmark":
      return <Icons.SvgBookmark style={props.style} />;
    case "calendar":
      return <Icons.SvgCalendar style={props.style} />;
    case "camera-animation-disabled":
      return <Icons.SvgCameraAnimationDisabled style={props.style} />;
    case "camera-animation":
      return <Icons.SvgCameraAnimation style={props.style} />;
    case "camera-retake":
      return <Icons.SvgCameraRetake style={props.style} />;
    case "camera":
      return <Icons.SvgCamera style={props.style} />;
    case "caret-down-small":
      return <Icons.SvgCaretDownSmall style={props.style} />;
    case "caret-down":
      return <Icons.SvgCaretDown style={props.style} />;
    case "caret-left-small":
      return <Icons.SvgCaretLeftSmall style={props.style} />;
    case "caret-left":
      return <Icons.SvgCaretLeft style={props.style} />;
    case "caret-right-small":
      return <Icons.SvgCaretRightSmall style={props.style} />;
    case "caret-right":
      return <Icons.SvgCaretRight style={props.style} />;
    case "caret-up-small":
      return <Icons.SvgCaretUpSmall style={props.style} />;
    case "caret-up":
      return <Icons.SvgCaretUp style={props.style} />;
    case "charts":
      return <Icons.SvgCharts style={props.style} />;
    case "chat":
      return <Icons.SvgChat style={props.style} />;
    case "checkbox-deselect":
      return <Icons.SvgCheckboxDeselect style={props.style} />;
    case "checkbox-select":
      return <Icons.SvgCheckboxSelect style={props.style} />;
    case "checkmark-small":
      return <Icons.SvgCheckmarkSmall style={props.style} />;
    case "checkmark":
      return <Icons.SvgCheckmark style={props.style} />;
    case "chevron-down":
      return <Icons.SvgChevronDown style={props.style} />;
    case "chevron-left-double":
      return <Icons.SvgChevronLeftDouble style={props.style} />;
    case "chevron-left":
      return <Icons.SvgChevronLeft style={props.style} />;
    case "chevron-right-double":
      return <Icons.SvgChevronRightDouble style={props.style} />;
    case "chevron-right":
      return <Icons.SvgChevronRight style={props.style} />;
    case "chevron-up":
      return <Icons.SvgChevronUp style={props.style} />;
    case "circle":
      return <Icons.SvgCircle style={props.style} />;
    case "clash":
      return <Icons.SvgClash style={props.style} />;
    case "clipboard":
      return <Icons.SvgClipboard style={props.style} />;
    case "clock":
      return <Icons.SvgClock style={props.style} />;
    case "close-circular":
      return <Icons.SvgCloseCircular style={props.style} />;
    case "close-small":
      return <Icons.SvgCloseSmall style={props.style} />;
    case "close":
      return <Icons.SvgClose style={props.style} />;
    case "cloud-download":
      return <Icons.SvgCloudDownload style={props.style} />;
    case "cloud-upload":
      return <Icons.SvgCloudUpload style={props.style} />;
    case "cloud":
      return <Icons.SvgCloud style={props.style} />;
    case "collapse-all":
      return <Icons.SvgCollapseAll style={props.style} />;
    case "collapse":
      return <Icons.SvgCollapse style={props.style} />;
    case "column-manager":
      return <Icons.SvgColumnManager style={props.style} />;
    case "compare":
      return <Icons.SvgCompare style={props.style} />;
    case "computer":
      return <Icons.SvgComputer style={props.style} />;
    case "configuration":
      return <Icons.SvgConfiguration style={props.style} />;
    case "copy":
      return <Icons.SvgCopy style={props.style} />;
    case "crop":
      return <Icons.SvgCrop style={props.style} />;
    case "crown":
      return <Icons.SvgCrown style={props.style} />;
    case "cursor-click":
      return <Icons.SvgCursorClick style={props.style} />;
    case "cursor":
      return <Icons.SvgCursor style={props.style} />;
    case "cut":
      return <Icons.SvgCut style={props.style} />;
    case "database":
      return <Icons.SvgDatabase style={props.style} />;
    case "developer":
      return <Icons.SvgDeveloper style={props.style} />;
    case "disconnect":
      return <Icons.SvgDisconnect style={props.style} />;
    case "distribute-bottom":
      return <Icons.SvgDistributeBottom style={props.style} />;
    case "distribute-center-horizontal":
      return <Icons.SvgDistributeCenterHorizontal style={props.style} />;
    case "distribute-center-vertical":
      return <Icons.SvgDistributeCenterVertical style={props.style} />;
    case "distribute-left":
      return <Icons.SvgDistributeLeft style={props.style} />;
    case "distribute-right":
      return <Icons.SvgDistributeRight style={props.style} />;
    case "distribute-top":
      return <Icons.SvgDistributeTop style={props.style} />;
    case "dock-bottom":
      return <Icons.SvgDockBottom style={props.style} />;
    case "dock-left":
      return <Icons.SvgDockLeft style={props.style} />;
    case "dock-right":
      return <Icons.SvgDockRight style={props.style} />;
    case "dock-top":
      return <Icons.SvgDockTop style={props.style} />;
    case "document-lock":
      return <Icons.SvgDocumentLock style={props.style} />;
    case "document-reference":
      return <Icons.SvgDocumentReference style={props.style} />;
    case "document":
      return <Icons.SvgDocument style={props.style} />;
    case "documentation":
      return <Icons.SvgDocumentation style={props.style} />;
    case "download":
      return <Icons.SvgDownload style={props.style} />;
    case "drag-handle-vertical":
      return <Icons.SvgDragHandleVertical style={props.style} />;
    case "drag-handle":
      return <Icons.SvgDragHandle style={props.style} />;
    case "draw":
      return <Icons.SvgDraw style={props.style} />;
    case "duplicate":
      return <Icons.SvgDuplicate style={props.style} />;
    case "edit-all":
      return <Icons.SvgEditAll style={props.style} />;
    case "ellipse":
      return <Icons.SvgEllipse style={props.style} />;
    case "email-at":
      return <Icons.SvgEmailAt style={props.style} />;
    case "email":
      return <Icons.SvgEmail style={props.style} />;
    case "exit":
      return <Icons.SvgExit style={props.style} />;
    case "expand-all":
      return <Icons.SvgExpandAll style={props.style} />;
    case "expand":
      return <Icons.SvgExpand style={props.style} />;
    case "export":
      return <Icons.SvgExport style={props.style} />;
    case "eyedropper-drop":
      return <Icons.SvgEyedropperDrop style={props.style} />;
    case "eyedropper-filled":
      return <Icons.SvgEyedropperFilled style={props.style} />;
    case "eyedropper":
      return <Icons.SvgEyedropper style={props.style} />;
    case "fast-backward":
      return <Icons.SvgFastBackward style={props.style} />;
    case "fast-forward":
      return <Icons.SvgFastForward style={props.style} />;
    case "feedback":
      return <Icons.SvgFeedback style={props.style} />;
    case "filter-hollow":
      return <Icons.SvgFilterHollow style={props.style} />;
    case "filter":
      return <Icons.SvgFilter style={props.style} />;
    case "find":
      return <Icons.SvgFind style={props.style} />;
    case "fire-extinguisher":
      return <Icons.SvgFireExtinguisher style={props.style} />;
    case "fit-to-view":
      return <Icons.SvgFitToView style={props.style} />;
    case "flag":
      return <Icons.SvgFlag style={props.style} />;
    default:
      return <></>;
  }
};

export default IconByName;
